
import { Base } from '../base-component';

import './press-releases.component.scss';

export class PressReleases extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/press-releases/press-releases.component.ts